// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"591":"3c339208","662":"975fff4e"}[chunkId] + ".chunk.css";
};